import { Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'

const SubSettingsArea = ({ text, children, sx = {} }) => {
  const theme = useTheme()

  return (
    <div>
      <Typography
        variant="h3"
        sx={{
          color: theme.palette.primary.main,
          pt: 1,
          ...sx,
          // Left-align the text
        }}
      >
        {text}
      </Typography>

      {children}
    </div>
  )
}

export default SubSettingsArea
